import { z } from 'zod';
export const ObraSchema = z.object({
    worksNo: z.string(),
    displayName: z.string(),
    description: z.string().nullable(),
    centroCosto: z.string().nullable(),
    areaCosteo: z.string().nullable(),
    proyectoPadre: z.string().nullable(),
    areaProrrateadaM2: z.number().nullable(),
    projectManager: z.string().nullable(),
    status: z.string().nullable(),
    startingDate: z.string().nullable(),
    endingDate: z.string().nullable(),
    origenPrincipal: z.enum(['PRODUCTION', 'SANDBOX']).nullable(),
});
export const ListaObrasSchema = z.array(ObraSchema);
//# sourceMappingURL=obra.schema.js.map